import React from 'react';

const FindYourFitChart = ({ chart }) => {
  return (
    <table className='tw:w-full tw:border tw:border-body tw:mx-[5px] tw:md:mx-[15px] tw:[&_tr:first-child>td]:pt-[17px] tw:[&_tr:last-child>td]:pb-[17px]'>
      <thead>
        <tr>
          <th className='tw:p-[10px] tw:md:p-[19px] tw:font-body tw:font-bold tw:uppercase tw:text-base tw:text-center tw:text-white tw:bg-body'>
            {chart.title}
          </th>
        </tr>
      </thead>
      <tbody>
        {chart.values.map((val) => (
          <tr key={`${chart.title}-${val}`}>
            <td className='tw:text-center tw:font-body tw:font-bold tw:text-body tw:text-base tw:p-2'>
              {val}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const FindYourFit = ({ charts, note }) => {
  return (
    <div id='FindYourFit' className='tw:bg-[#f8f6f0] tw:px-[15px] tw:py-[60px] tw:mt-10 tw:lg:mt-20'>
      <h2 className='tw:font-title tw:font-bold tw:text-center tw:text-[28px] tw:leading-10 tw:lg:text-2xl tw:lg:leading-8 tw:text-body tw:mb-[30px]'>
        Find Your Fit
      </h2>

      <div className='tw:max-w-[800px] tw:mx-auto tw:flex tw:justify-between tw:overflow-y-auto tw:pb-[10px]'>
        {charts.map((chart, idx) => (
          <FindYourFitChart key={chart + idx} chart={chart} />
        ))}
      </div>

      {note && (
        <p
          className='tw:text-center tw:font-body tw:text-sm tw:mt-5 tw:mx-auto tw:font-normal tw:text-body tw:[&_b]:font-bold tw:[&_strong]:font-bold'
          dangerouslySetInnerHTML={{ __html: note }}></p>
      )}
    </div>
  );
};

export default FindYourFit;
